import { useCallback, useEffect, useState } from "react";
import { get, post } from "../_services/apiService";
import { API_URL } from "../_services/apiUrl";
import { toast } from "react-toastify";
import DetailOfProduct from "./Shared/DetailOfProduct";
import ImageSection from "./Shared/ImageSection";
import CustomerReviews from "./Shared/CustomerReviews";
import { decryptData } from "../_services/encDnc";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "./Shared/Layout";
import ServicesSection from "./HomePage/ServicesSection";
import { ToastContainer } from "react-toastify";

const ProductDetail = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    const navigate = useNavigate();
    const loginId = localStorage.getItem('loginId');
    const [productDetailById, setProductDataById] = useState([]);
    const [userAddress, setUserAdderss] = useState([]);
    const [productRating, setProductRating] = useState([]);
    const params = useParams();
    const productId = params?.id;

    const [ratingForm, setRatingForm] = useState({
        isActive: true,
        ratingId: 0,
        loginId: loginId ? Number(loginId) : 0,
        createdBy: 0,
        productId: 0,
        ratting: 0,
        remark: ""
    });

    const GetProductRatingByProductId = useCallback(async () => {
        try {
            setLoading(true);
            const response = await get(API_URL.GetProductRatingByProductId, {
                pProductId: productId,
            });

            if (response.isSuccess === 200) {
                setProductRating(response.data);
            }
        } catch (error) {
            setProductRating([]);
        } finally {
            setLoading(false);
        }
    }, [productId]);

    const GetProductDetailById = useCallback(async () => {
        try {
            const response = await get(API_URL.GetProductDetailById, {
                pProductDetailId: productId,
            });
            if (response.isSuccess === 200) {
                const encryptedData = response.data;
                const result = decryptData(encryptedData);
                setProductDataById(result[0]);
            } else {
                setError('Product Detail Not Avaiable');
            }
        } catch (error) {
            setError('Product Detail Not Avaiable');
        } finally {
            setLoading(false);
        }
    }, [productId]);

    const getUserAddressByLoginId = useCallback(async () => {
        if (loginId) {
            try {
                setLoading(true);
                const response = await get(`${API_URL?.GetUserAddressByLoginId}?pLoginId=${loginId}`);

                const encryptedData = response.data;
                const result = decryptData(encryptedData);

                if (response.isSuccess === 200) {
                    setUserAdderss(result);
                } else {
                    setUserAdderss([]);
                }
            } catch (error) {
                setUserAdderss([]);
            } finally {
                setLoading(false);
            }
        }
    }, [loginId]);

    useEffect(() => {
        GetProductDetailById();
        getUserAddressByLoginId();
        GetProductRatingByProductId();
    }, [GetProductDetailById, getUserAddressByLoginId, GetProductRatingByProductId]);

    useEffect(() => {
        setRatingForm((prevState) => ({
            ...prevState,
            productId: productDetailById?.productId
        }));
    }, [productDetailById]);

    const saveRatingData = async (event) => {
        event.preventDefault();

        if (!ratingForm.ratting || !ratingForm.remark) {
            toast.error("Please select a rating and provide a remark.");
            return;
        }

        if (loginId) {
            setLoading(true);
            try {
                const response = await post(API_URL.SaveProductRating, ratingForm);
                if (response.isSuccess === 200) {
                    toast.success('You have Successfully Rate this Product');
                    GetProductRatingByProductId();
                    GetProductDetailById();
                } else if (response.isSuccess === 404) {
                    toast.error('You have already Rate this Product');
                }
            } catch (error) {
                toast.error("Failed to Rate this Product");
            } finally {
                setRatingForm({
                    isActive: true,
                    ratingId: 0,
                    loginId: loginId ? Number(loginId) : 0,
                    createdBy: 0,
                    productId: productDetailById?.productId ? productDetailById?.productId : 0,
                    ratting: 0,
                    remark: ""
                });
                setLoading(false);
            }
        } else {
            navigate('/login');
        }
    };

    if (loading) return <div className="loading_content"><img src="./images/loading.gif" alt=""/></div>;

    return (
        <Layout>
            <ToastContainer
                position="top-right"
                className="toaster"
                autoClose={1500}
                hideProgressBar={true}
                pauseOnHover={false}
                draggable={false}
            />
            <section className="same_space layout_main">
                <div className="container">
                    <div className="row">
                        <ImageSection productDetail={productDetailById} setError={setError} error={error} />
                        <DetailOfProduct
                            productDetail={productDetailById}
                            userAddress={userAddress}
                            GetProductDetailById={GetProductDetailById}
                            setError={setError}
                            error={error}
                        />
                    </div>
                    <div>
                        <CustomerReviews
                            productDetail={productDetailById}
                            ratingForm={ratingForm}
                            setRatingForm={setRatingForm}
                            saveRatingData={saveRatingData}
                            productRating={productRating}
                            setError={setError}
                            error={error}
                        />
                    </div>
                    <div className="mt-4">
                        <ServicesSection />
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default ProductDetail;